/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type Status = typeof Status[keyof typeof Status];


export const Status = {
  START_SDK: 'START_SDK',
  REVIEW_PENDING: 'REVIEW_PENDING',
  SUCCESS: 'SUCCESS',
  FRAUD: 'FRAUD',
  ABORTED: 'ABORTED',
  OTHER: 'OTHER',
} as const;
